module.exports = __webpack_public_path__ + "img/empty_state.6efb2bd1.png";